module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": "confirm_size",
      "title": "Follow Up Questions",
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.handleCloseModal
    }
  }, [_c('div', {
    staticClass: "flex flex-col h-full"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-6 flex-grow h-full px-6 pt-2 pb-4"
  }, [_c('div', {
    staticClass: "text-gray-800 font-poppins"
  }, [_vm._v("\n        You can "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("edit the questions")]), _vm._v(" in discussion tab. This action can be undone.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isToGoDiscussionTab),
      expression: "isToGoDiscussionTab"
    }],
    staticClass: "cursor-pointer",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isToGoDiscussionTab) ? _vm._i(_vm.isToGoDiscussionTab, null) > -1 : (_vm.isToGoDiscussionTab)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isToGoDiscussionTab,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isToGoDiscussionTab = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isToGoDiscussionTab = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isToGoDiscussionTab = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-sm font-poppins text-gray-700"
  }, [_c('p', {}, [_vm._v("Go to Discussion Tab")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2 justify-between px-6 pb-5 pt-2"
  }, [_c('button', {
    staticClass: "w-full px-4 py-2 bg-gray-50 rounded-md hover:bg-gray-100 border border-solid border-gray-200 text-gray-700",
    on: {
      "click": function($event) {
        return _vm.handleCloseModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "w-full px-4 py-2 bg-primary flex items-center space-x-2 rounded-md hover:bg-primary-dark border border-solid border-primary text-white",
    on: {
      "click": function($event) {
        return _vm.handleAddQuestions()
      }
    }
  }, [_c('span', [_vm._v("Add Follow Up Questions")]), _vm._v(" "), (_vm.isAdding === true) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-214e8605!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/Modals/FollowUpQuestionsTranscription.vue
// module id = 1902
// module chunks = 61